import { render, staticRenderFns } from "./addorder.vue?vue&type=template&id=04dd9a5b&scoped=true"
import script from "./addorder.vue?vue&type=script&lang=js"
export * from "./addorder.vue?vue&type=script&lang=js"
import style0 from "./addorder.vue?vue&type=style&index=0&id=04dd9a5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dd9a5b",
  null
  
)

export default component.exports